import { z } from 'zod';
export var FlowRunExportJobCancellationStatus;
(function (FlowRunExportJobCancellationStatus) {
    FlowRunExportJobCancellationStatus["Submitted"] = "Submitted";
})(FlowRunExportJobCancellationStatus || (FlowRunExportJobCancellationStatus = {}));
export const FlowRunExportJobCancelResponseSchema = z.object({
    status: z.enum(FlowRunExportJobCancellationStatus),
});
//# sourceMappingURL=exportJob.js.map